import { FinancialClient } from '../api/types';
import { useApi } from './api.hooks';
import { useQuery, UseQueryResult } from 'react-query';

export function useClients(): UseQueryResult<FinancialClient[], unknown> {
	const api = useApi();
	return useQuery('finance.clients.getAll', api.finance.clients.getAll);
}
